module.exports = __webpack_public_path__ + "assets/img/3.4f0bf3a0.png";